export default __webpack_public_path__ + "static/media/app2.cde0cd3c.png";